const LSKEY = Object.freeze({
  gitver: 'gitVersionFetched',
  cookies: 'cookieChoice',
});

export default LSKEY;
